import { format } from 'date-fns';
import { DateRange } from 'react-day-picker';

export const DATE_FORMAT = 'dd.MM.yyyy';

const formatRange = (value: DateRange | undefined) => {
  if (!value?.from) {
    return '';
  }

  if (!value.to) {
    return `${format(value.from, DATE_FORMAT)} — `;
  }

  return `${format(value.from, DATE_FORMAT)} — ${format(value.to, DATE_FORMAT)}`;
};

export default formatRange;
